import {
  Avatar,
  createStyles,
  Group,
  MantineColor,
  Paper,
  Text,
} from '@mantine/core';
import React, { ReactNode } from 'react';

export interface KpiWidgetType {
  title: string;
  avatarColor: MantineColor;
  label: ReactNode;
  icon: ReactNode;
}

interface KPIWidgetProps {
  kpiWidget: KpiWidgetType;
}

export function KpiWidget({ kpiWidget }: KPIWidgetProps) {
  const { classes } = useStyles(kpiWidget?.avatarColor);

  return (
    <Paper radius="md" className={classes.container}>
      <Group spacing="md">
        <Avatar
          radius="lg"
          className={classes.avatar}
          styles={(theme) => ({
            placeholder: {
              backgroundColor: theme.fn.rgba(
                theme.colors[kpiWidget?.avatarColor]?.[7] ||
                  theme.colors.blue_gray[7],
                0.1
              ),
            },
          })}
        >
          {kpiWidget.icon}
        </Avatar>

        <div>
          <Text className={classes.counter}>{kpiWidget.label}</Text>
          <Text className={classes.title}>{kpiWidget.title}</Text>
        </div>
      </Group>
    </Paper>
  );
}

const useStyles = createStyles((theme, avatarColor: string) => ({
  container: {
    padding: theme.spacing.xl,
    border: `1px solid ${theme.colors.gray[2]}`,
    minWidth: 'max-content',
  },

  avatar: {
    width: 60,
    height: 60,
    minWidth: 60,

    svg: {
      color: theme.colors[avatarColor][4],
      width: 32,
      height: 32,
    },
  },

  counter: {
    fontSize: 32,
    color: theme.colors.blue_gray[9],
  },

  title: {
    color: theme.colors.blue_gray[4],
    fontSize: theme.fontSizes.sm,
  },
}));
